import BaseStore from '../../base-store'

let options = {}
export default new BaseStore('artist-categories', options)



// WEBPACK FOOTER //
// ./src/store/modules/configuration/artist-categories.store.js